export default __webpack_public_path__ + "static/media/home-cafe-img-02.6f2e94dc.jpg";